// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Users_page__3aSTS {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* ===== Stat cards (filtros) ===== */
.Users_statGrid__T9z0x {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}
.Users_statCard__h5-D2 {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  text-align: left;
  background: var(--dylo-surface);
  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);
  border-radius: 14px;
  box-shadow: var(--shadow-card);
  cursor: pointer;
  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}
.Users_statCard__h5-D2:hover {
  transform: translateY(-2px);
}
.Users_statActive__\\+XrZY {
  border-color: var(--stat-color);
  box-shadow: 0 0 0 1px var(--stat-color), var(--shadow-card);
}
.Users_statIcon__JSIb3 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 12px;
  color: var(--stat-color);
  background: color-mix(in srgb, var(--stat-color) 14%, transparent);
}
.Users_statText__k8q7j {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.Users_statLabel__7o0T3 {
  font-size: 13.5px;
  font-weight: 500;
  color: var(--dylo-text);
}
.Users_statValue__ByJE4 {
  font-size: 26px;
  font-weight: 700;
  color: var(--stat-color);
  line-height: 1;
}

@media (max-width: 620px) {
  .Users_statGrid__T9z0x {
    grid-template-columns: 1fr;
  }
}

.Users_header__83cVu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 18px;
}
.Users_title__Y95UY {
  font-size: 26px;
  font-weight: 700;
  color: var(--dylo-ink);
  margin: 0;
}
.Users_headerActions__Pg9YC {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}
.Users_search__oxsSA {
  width: 320px;
  max-width: 100%;
}
.Users_newBtn__wiLlq {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  background: var(--dylo-orange) !important;
  border: none !important;
}
.Users_newBtn__wiLlq:hover {
  background: var(--dylo-orange-hover) !important;
}

/* ===== Tabla ===== */
.Users_tableWrap__EfKeJ {
  width: 100%;
}
.Users_tableHead__3CNhX,
.Users_row__2\\+DVN {
  display: grid;
  grid-template-columns: 1.4fr 1.8fr 1fr 0.8fr 0.9fr;
  align-items: center;
  gap: 12px;
}
.Users_tableHead__3CNhX {
  padding: 12px 18px;
  background: var(--dylo-field-bg);
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
  color: var(--dylo-text);
}
.Users_tableBody__LJnd8 {
  display: flex;
  flex-direction: column;
}
.Users_row__2\\+DVN {
  padding: 16px 18px;
  border-bottom: 1px solid var(--dylo-line);
  font-size: 13.5px;
  color: var(--dylo-text);
  animation: Users_dylo-fade-in__VKmx8 0.28s ease both;
}
.Users_row__2\\+DVN:last-child {
  border-bottom: none;
}
.Users_center__24QhP {
  text-align: center;
  justify-self: center;
}
.Users_name__\\+qobe {
  font-weight: 600;
  color: var(--dylo-ink);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Users_mail__mjGz6 {
  color: var(--dylo-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Users_loads__CKXx\\+ {
  font-weight: 600;
  color: var(--dylo-ink);
}

.Users_statusPill__c-u-e {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 84px;
  padding: 5px 14px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.Users_active__2sfXQ {
  color: #2aad27;
  background: color-mix(in srgb, #2aad27 12%, transparent);
  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);
}
.Users_inactive__8sT1Z {
  color: var(--dylo-danger);
  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);
}

.Users_detailBtn__mpjs9 {
  padding: 6px 18px !important;
  border: 1px solid var(--dylo-surface-border) !important;
  background: transparent !important;
  color: var(--dylo-ink) !important;
  font-size: 12.5px !important;
  border-radius: 8px !important;
}
.Users_detailBtn__mpjs9:hover {
  border-color: var(--dylo-teal-500) !important;
  color: var(--dylo-teal-700) !important;
}

.Users_empty__hwUya {
  padding: 40px;
  text-align: center;
  color: var(--dylo-muted);
  font-size: 14px;
}

/* Utilidades skeleton */
.Users_skIconBox__84Gih {
  border-radius: 12px !important;
}
.Users_skRounded__sePkp {
  border-radius: 999px !important;
}

@media (max-width: 820px) {
  .Users_tableHead__3CNhX {
    display: none;
  }
  .Users_row__2\\+DVN {
    grid-template-columns: 1fr 1fr;
    gap: 6px 12px;
    padding: 14px 16px;
  }
  .Users_mail__mjGz6 {
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Users/Users.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,sEAAsE;EACtE,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gFAAgF;AAClF;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,+BAA+B;EAC/B,2DAA2D;AAC7D;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,kEAAkE;AACpE;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,yCAAyC;EACzC,uBAAuB;AACzB;AACA;EACE,+CAA+C;AACjD;;AAEA,sBAAsB;AACtB;EACE,WAAW;AACb;AACA;;EAEE,aAAa;EACb,kDAAkD;EAClD,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,uBAAuB;EACvB,oDAAuC;AACzC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,wDAAwD;EACxD,8DAA8D;AAChE;AACA;EACE,yBAAyB;EACzB,mEAAmE;EACnE,yEAAyE;AAC3E;;AAEA;EACE,4BAA4B;EAC5B,uDAAuD;EACvD,kCAAkC;EAClC,iCAAiC;EACjC,4BAA4B;EAC5B,6BAA6B;AAC/B;AACA;EACE,6CAA6C;EAC7C,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,8BAA8B;AAChC;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* ===== Stat cards (filtros) ===== */\n.statGrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n.statCard {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  text-align: left;\n  background: var(--dylo-surface);\n  border: var(--dylo-card-border-width) solid var(--dylo-surface-border);\n  border-radius: 14px;\n  box-shadow: var(--shadow-card);\n  cursor: pointer;\n  transition: border-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;\n}\n.statCard:hover {\n  transform: translateY(-2px);\n}\n.statActive {\n  border-color: var(--stat-color);\n  box-shadow: 0 0 0 1px var(--stat-color), var(--shadow-card);\n}\n.statIcon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 46px;\n  height: 46px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  color: var(--stat-color);\n  background: color-mix(in srgb, var(--stat-color) 14%, transparent);\n}\n.statText {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n.statLabel {\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--dylo-text);\n}\n.statValue {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--stat-color);\n  line-height: 1;\n}\n\n@media (max-width: 620px) {\n  .statGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 18px;\n}\n.title {\n  font-size: 26px;\n  font-weight: 700;\n  color: var(--dylo-ink);\n  margin: 0;\n}\n.headerActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.search {\n  width: 320px;\n  max-width: 100%;\n}\n.newBtn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  background: var(--dylo-orange) !important;\n  border: none !important;\n}\n.newBtn:hover {\n  background: var(--dylo-orange-hover) !important;\n}\n\n/* ===== Tabla ===== */\n.tableWrap {\n  width: 100%;\n}\n.tableHead,\n.row {\n  display: grid;\n  grid-template-columns: 1.4fr 1.8fr 1fr 0.8fr 0.9fr;\n  align-items: center;\n  gap: 12px;\n}\n.tableHead {\n  padding: 12px 18px;\n  background: var(--dylo-field-bg);\n  border-radius: 12px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--dylo-text);\n}\n.tableBody {\n  display: flex;\n  flex-direction: column;\n}\n.row {\n  padding: 16px 18px;\n  border-bottom: 1px solid var(--dylo-line);\n  font-size: 13.5px;\n  color: var(--dylo-text);\n  animation: dylo-fade-in 0.28s ease both;\n}\n.row:last-child {\n  border-bottom: none;\n}\n.center {\n  text-align: center;\n  justify-self: center;\n}\n.name {\n  font-weight: 600;\n  color: var(--dylo-ink);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.mail {\n  color: var(--dylo-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.loads {\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n\n.statusPill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 84px;\n  padding: 5px 14px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.3px;\n}\n.active {\n  color: #2aad27;\n  background: color-mix(in srgb, #2aad27 12%, transparent);\n  border: 1px solid color-mix(in srgb, #2aad27 45%, transparent);\n}\n.inactive {\n  color: var(--dylo-danger);\n  background: color-mix(in srgb, var(--dylo-danger) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--dylo-danger) 45%, transparent);\n}\n\n.detailBtn {\n  padding: 6px 18px !important;\n  border: 1px solid var(--dylo-surface-border) !important;\n  background: transparent !important;\n  color: var(--dylo-ink) !important;\n  font-size: 12.5px !important;\n  border-radius: 8px !important;\n}\n.detailBtn:hover {\n  border-color: var(--dylo-teal-500) !important;\n  color: var(--dylo-teal-700) !important;\n}\n\n.empty {\n  padding: 40px;\n  text-align: center;\n  color: var(--dylo-muted);\n  font-size: 14px;\n}\n\n/* Utilidades skeleton */\n.skIconBox {\n  border-radius: 12px !important;\n}\n.skRounded {\n  border-radius: 999px !important;\n}\n\n@media (max-width: 820px) {\n  .tableHead {\n    display: none;\n  }\n  .row {\n    grid-template-columns: 1fr 1fr;\n    gap: 6px 12px;\n    padding: 14px 16px;\n  }\n  .mail {\n    grid-column: 1 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Users_page__3aSTS`,
	"statGrid": `Users_statGrid__T9z0x`,
	"statCard": `Users_statCard__h5-D2`,
	"statActive": `Users_statActive__+XrZY`,
	"statIcon": `Users_statIcon__JSIb3`,
	"statText": `Users_statText__k8q7j`,
	"statLabel": `Users_statLabel__7o0T3`,
	"statValue": `Users_statValue__ByJE4`,
	"header": `Users_header__83cVu`,
	"title": `Users_title__Y95UY`,
	"headerActions": `Users_headerActions__Pg9YC`,
	"search": `Users_search__oxsSA`,
	"newBtn": `Users_newBtn__wiLlq`,
	"tableWrap": `Users_tableWrap__EfKeJ`,
	"tableHead": `Users_tableHead__3CNhX`,
	"row": `Users_row__2+DVN`,
	"tableBody": `Users_tableBody__LJnd8`,
	"dylo-fade-in": `Users_dylo-fade-in__VKmx8`,
	"center": `Users_center__24QhP`,
	"name": `Users_name__+qobe`,
	"mail": `Users_mail__mjGz6`,
	"loads": `Users_loads__CKXx+`,
	"statusPill": `Users_statusPill__c-u-e`,
	"active": `Users_active__2sfXQ`,
	"inactive": `Users_inactive__8sT1Z`,
	"detailBtn": `Users_detailBtn__mpjs9`,
	"empty": `Users_empty__hwUya`,
	"skIconBox": `Users_skIconBox__84Gih`,
	"skRounded": `Users_skRounded__sePkp`
};
export default ___CSS_LOADER_EXPORT___;
